import React, { useState, useEffect, useContext } from "react";
import { Form, Input, Space } from "antd";
import { getFormItemLabel } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { parsePhoneNumberFromString } from "libphonenumber-js/max";
import parseMobile from "libphonenumber-js/mobile";
import selectData from "../../assets/country_codes_with_flags.json";
import PhoneInputWrapper from "./PhoneInputWrapper.style";
import { Select } from "antd";
import RestrictedContext from "../util/RestrictedContext";
const { Option } = Select;

const PhoneInputComponent = ({ value, onChange, disabled, isMobile }) => {
  const restricted = useContext(RestrictedContext);
  const [countryCode, setCountryCode] = useState("+972");
  const [localNumber, setLocalNumber] = useState("");
  const getLocalPhoneNumber = (value) => {
    const phoneNumber = value && parsePhoneNumberFromString(value);
    if (phoneNumber) {
      const nationalNumber = phoneNumber.nationalNumber;
      // Add leading zero for Israeli numbers
      return phoneNumber.countryCallingCode === "972"
        ? "0" + nationalNumber
        : nationalNumber;
    }
    return null;
  };

  const getNumberWithoutNationalCode = (value) => {
    if (value && typeof value === "string") {
      const codePattern = new RegExp(`^\\${countryCode}`);
      return value.replace(codePattern, "");
    }
    return "";
  };

  const onSelect = (code) => {
    setCountryCode(code);
    convertToValid(code, localNumber);
  };

  const onPhoneChange = (e) => {
    const newLocalNumber = e.target.value;
    setLocalNumber(newLocalNumber);
    convertToValid(countryCode, newLocalNumber);
  };

  const convertToValid = (code, number) => {
    if (number.trim() === "") {
      onChange(null);
    } else {
      // Remove leading zero only when sending the full number
      const cleanNumber = number.startsWith("0") ? number.slice(1) : number;
      onChange(`${code}${cleanNumber}`);
    }
  };

  const displayValue = () => {
    if (!value) return "";
    const localPhoneNumber = getLocalPhoneNumber(value);
    if (localPhoneNumber !== null) {
      return localPhoneNumber;
    }
    return localNumber || getNumberWithoutNationalCode(value);
  };

  const select = (
    <Select
      optionLabelProp="label"
      popupClassName="dropdown"
      popupMatchSelectWidth={false}
      value={countryCode}
      onSelect={onSelect}
      disabled={disabled || !restricted["hasWritePermission"]}
    >
      {selectData.map((item) => (
        <Option key={item.name} value={item.number} label={item.number}>
          <div style={{ direction: "ltr" }}>
            <img
              alt="#"
              style={{ height: "16px", width: "24px" }}
              src={item.flag}
            />
            <span
              style={{
                padding: "0 6px 0 30px",
              }}
            >
              {item.name}{" "}
            </span>
            <span>{item.number} </span>
          </div>
        </Option>
      ))}
    </Select>
  );
  return (
    <PhoneInputWrapper>
      <Space.Compact>
        <Input
          value={displayValue()}
          style={{ width: "100%", direction: "ltr", textAlign: "left" }}
          onChange={onPhoneChange}
          disabled={disabled || !restricted["hasWritePermission"]}
        />
        {select}
      </Space.Compact>
    </PhoneInputWrapper>
  );
};

const PhoneNumberItem = (props) => {
  const { name, required, category, disabled, isMobile, hideLabel } = props;
  const intl = useIntl();
  const phoneValidation = (value) => {
    let valid = false;
    if (value) {
      const phoneNumber = isMobile
        ? parseMobile(value)
        : parsePhoneNumberFromString(value);
      let isnum = value.substring(1).match(/^[0-9]+$/) != null;
      if (phoneNumber && isnum) {
        valid = phoneNumber.isValid();
      }
    }
    return valid || !value;
  };
  const label = getFormItemLabel(intl, category, name, null);
  const requiredMessage =
    label +
    " " +
    intl.formatMessage({
      id: "app.forms.requiredMessage",
    });

  return (
    <Form.Item
      label={hideLabel ? null : label}
      name={name}
      rules={[
        {
          required: required,
          message: requiredMessage,
        },
        ({ getFieldValue }) => ({
          validator(rule, value) {
            if (phoneValidation(value)) {
              return Promise.resolve();
            }
            return Promise.reject(
              intl.formatMessage({
                id: "app.forms.phoneValidationMessage",
              })
            );
          },
        }),
      ]}
    >
      <PhoneInputComponent disabled={disabled} isMobile={isMobile} />
    </Form.Item>
  );
};

PhoneNumberItem.propTypes = {
  name: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  required: PropTypes.bool,
  category: PropTypes.string,
  disabled: PropTypes.bool,
};

export default PhoneNumberItem;
